import {
  put
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';


// Advance Security
export function* handleAdvancedSecuritySaga(action) {
  
  // console.log('called from GET Advance Security METHOD')
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
// yield put(actions.getAdvanceSecurity())
  if (sessionToken) {
    yield put(actions.getAdvancedSecurityStart());
    
    try {
      let response = {};
      if(action.method === 'POST'){
        response = yield axios.post(
          '/advancedSecurity',
          {
            enabled:action.enabled,
            listenOnly:false
          }
        )
      } else {
        response = yield axios.get(
          '/advancedSecurity'
        )
      }
      
      // alert('came into if');
      // console.log('advance security response :::', response);
      if(response.status === 200){       
        yield put(actions.setAdvancedSecurity(response.data))
        yield put(actions.setAdvancedSecuritySuccess());
      }else{
        yield put(actions.setAdvancedSecurityFailed());
      }

    } catch (error) {
      yield put(actions.setAdvancedSecurityFailed());
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.setAdvancedSecurityFailed());
  } 

}


